// extracted by mini-css-extract-plugin
module.exports = {"title":"QRCode_title__2jqfK","component":"QRCode_component__3mqaW","info":"QRCode_info__3xHRy","encoded":"QRCode_encoded__1EXMa","copy":"QRCode_copy__195gW"};